import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CircularProgress, Stack } from "@mui/material";
import { authClient } from "../lib/auth-client";

export const AdminProtectedRoute = () => {
  const { data: session, isPending } = authClient.useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100vh">
        <CircularProgress />
      </Stack>
    );
  }

  if (!session) {
    return (
      <Navigate
        state={{ from: location.pathname }}
        replace
        to="/sign-in"
      />
    );
  }

  if (session.session?.is_admin !== true) {
    return <Navigate replace to="/dashboard" />;
  }

  return <Outlet />;
};
